(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/new-game.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/new-game.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$ui$ReactAccordio = svs.ui.ReactAccordion,
  Accordion = _svs$ui$ReactAccordio.Accordion,
  AccordionItem = _svs$ui$ReactAccordio.AccordionItem,
  AccordionSummary = _svs$ui$ReactAccordio.AccordionSummary,
  AccordionDetails = _svs$ui$ReactAccordio.AccordionDetails;
const fetchProducts = svs.arena.store.teams.actions.fetchProducts;
const InlineErrorMessage = svs.components.tb_ui_react.inlineMessage.InlineErrorMessage;
const NewGameItem = svs.arena.pages.teams.components.NewGameItem;
const hooks = svs.arena.shared.hooks;
const NewGame = _ref => {
  let teamId = _ref.teamId;
  const dispatch = ReactRedux.useDispatch();
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isTeamMissingError = _React$useState2[0],
    setIsTeamMissingError = _React$useState2[1];
  const _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isExpandedTrack = _React$useState4[0],
    setIsExpandedTrack = _React$useState4[1];
  const _hooks$useProducts = hooks.useProducts(),
    data = _hooks$useProducts.data,
    error = _hooks$useProducts.error;
  const isError = error || isTeamMissingError;
  React.useEffect(() => {
    if (!teamId) {
      setIsTeamMissingError(true);
    } else {
      setIsTeamMissingError(false);
    }
  }, [teamId]);
  const trackClick = () => {
    setIsExpandedTrack(current => !current);
    const track = {
      category: 'spela-tillsammans',
      action: 'play_new_game',
      opt_label: isExpandedTrack ? 'card_click' : 'card_closed'
    };
    svs.components.analytics.trackEvent(track);
  };
  return React.createElement("div", null, React.createElement(Accordion, {
    className: "margin-top-1"
  }, React.createElement(AccordionItem, {
    onChange: trackClick
  }, React.createElement(AccordionSummary, null, "L\xE4gg nytt spel"), React.createElement(AccordionDetails, {
    className: "padding-override-0"
  }, isError && React.createElement(InlineErrorMessage, {
    actions: [{
      handleClick: () => dispatch(fetchProducts()),
      text: 'Försök igen'
    }],
    header: "Tillf\xE4lligt fel!",
    icon: "exclamation-sign"
  }, "N\xE5gonting gick fel n\xE4r dina produkter skulle visas upp. F\xF6rs\xF6k igen om en stund."), !isError && (data === null || data === void 0 ? void 0 : data.map(product => React.createElement(React.Fragment, {
    key: product.productName + (product.productId && !product.productId.isArray ? product.productId : 'noId')
  }, React.createElement(NewGameItem, {
    product: product,
    teamId: teamId
  }))))))));
};
svs.arena.pages.teams.components.NewGame = NewGame;

 })(window);